export const YouTubePlayer = ({ videoId, title }) => {
  if (!videoId) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        background: '#0f0f0f',
        color: '#aaa',
        flexDirection: 'column',
        gap: 16,
        fontFamily: 'Arial, sans-serif',
        padding: 32,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 24, opacity: 0.6, border: '1px solid #555', padding: '6px 10px' }}>VIDEO</div>
        <div style={{ fontSize: 18, color: '#e0e0e0', fontWeight: 'bold' }}>
          This video is no longer available.
        </div>
        <div style={{ fontSize: 13, color: '#777', maxWidth: 360, lineHeight: 1.6 }}>
          The account associated with this video has been terminated for violating
          our Community Guidelines (Section 14.3: Insufficient Monetization Potential).
        </div>
        <div style={{ fontSize: 11, color: '#444', marginTop: 8 }}>
          YouBoob LLC — A Profit Dynamics International™ subsidiary.<br />
          Your watch history has been retained for advertiser use.
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', background: '#000', display: 'flex', flexDirection: 'column' }}>
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
        title={title || 'YouBoob Video'}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ width: '100%', flex: 1, border: 'none' }}
      />
    </div>
  );
};

export default YouTubePlayer;
